import * as TP from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DataDictionaryQueryVariables = TP.Exact<{ [key: string]: never; }>;


export type DataDictionaryQuery = (
  { readonly __typename?: 'Query' }
  & { readonly tenantConfiguration?: TP.Maybe<(
    { readonly __typename?: 'DataDictionary' }
    & { readonly types: ReadonlyArray<(
      { readonly __typename?: 'DataDictionaryTypes' }
      & Pick<TP.DataDictionaryTypes, 'id' | 'name'>
      & { readonly options: ReadonlyArray<(
        { readonly __typename?: 'DataDictionaryOptions' }
        & Pick<TP.DataDictionaryOptions, 'id' | 'active' | 'metadataJson' | 'name' | 'shortDisplayName' | 'parentTermOptionId' | 'externalRefIds'>
      )> }
    )> }
  )> }
);


export const DataDictionaryDocument = gql`
    query dataDictionary {
  tenantConfiguration: dataDictionary {
    types {
      id
      name
      options {
        id
        active
        metadataJson
        name
        shortDisplayName
        parentTermOptionId
        externalRefIds
      }
    }
  }
}
    `;

/**
 * __useDataDictionaryQuery__
 *
 * To run a query within a React component, call `useDataDictionaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataDictionaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataDictionaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataDictionaryQuery(baseOptions?: Apollo.QueryHookOptions<DataDictionaryQuery, DataDictionaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataDictionaryQuery, DataDictionaryQueryVariables>(DataDictionaryDocument, options);
      }
export function useDataDictionaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataDictionaryQuery, DataDictionaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataDictionaryQuery, DataDictionaryQueryVariables>(DataDictionaryDocument, options);
        }
export type DataDictionaryQueryHookResult = ReturnType<typeof useDataDictionaryQuery>;
export type DataDictionaryLazyQueryHookResult = ReturnType<typeof useDataDictionaryLazyQuery>;
export type DataDictionaryQueryResult = Apollo.QueryResult<DataDictionaryQuery, DataDictionaryQueryVariables>;
/** Cypress helper for mocking the dataDictionary query */
export const mockDataDictionary = (
  response: MockResponse<DataDictionaryQuery>,
  kwargs?: Cypress.GqlKwargs
): void => cy.gql<DataDictionaryQuery>('dataDictionary', response as anyOk, kwargs);